import * as neutralTokens from '../generated/tokens';
import getChakraThemeFromTokens from '../getChakraThemeFromTokens';

const neutralTheme = getChakraThemeFromTokens(neutralTokens);

export type Theme = typeof neutralTheme;
export default neutralTheme;
